// Hook odpowiedzialny za pobranie koszyka

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

// typ zwracanych danych
export interface IResponse {
  cart_id: number;
  cart_price_gross?: number;
  cart_price_gross_formatted?: string;
  cart_price_net?: number;
  cart_price_net_formatted?: string;
  delivery_price?: number;
  delivery_price_formatted?: string;
  delivery_method?: string;
  delivery_method_name?: string;
  payment_method?: string;
  payment_method_name?: string;
  payment_price?: number;
  currency: string;
  total_price_gross?: number;
  total_price_gross_formatted?: string;
  total_price_net?: number;
  total_price_net_formatted?: string;
  total_base_price_gross: number | null;
  total_base_price_gross_formatted: string | null;
  total_base_price_net: number | null;
  total_base_price_net_formatted: string | null;
  total_discount_gross: number | null;
  total_discount_gross_formatted: string | null;
  total_discount_net: number | null;
  total_discount_net_formatted: string | null;
  payment_price_formatted?: string;
}

const getCart = (id: number): Promise<IResponse> => axios.get(`/carts/${id}`);

export const useGetCart = (id: number, options?: UseQueryOptions<IResponse, IError>) =>
  useQuery<IResponse, IError>(['cart', id], () => getCart(id), options);
